import React from "react";
import { AdminTemplate, SalesmanBonusDashboard } from "../../components";

export const SalesmanDashboardPage = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Satış Performans Paneli",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={true}
        >
            <SalesmanBonusDashboard />
        </AdminTemplate>
    );
};
